// src/data/mockData.js

const leaderboardData = [
    { name: "CryptoNinja", score: 10, streak: 5 },
    { name: "BlockQueen", score: 9, streak: 4 },
    { name: "PiHunter", score: 9, streak: 3 },
    { name: "Mike", score: 8, streak: 3 },
    { name: "TokenTiger", score: 7, streak: 2 },
    { name: "SatoshiSeeker", score: 7, streak: 2 },
    { name: "ChainChampion", score: 6, streak: 1 },
    { name: "MinerMind", score: 5, streak: 1 },
    { name: "LedgerLegend", score: 5, streak: 1 },
    { name: "AltcoinAce", score: 4, streak: 0 },
    { name: "DAppDynamo", score: 4, streak: 0 },
    { name: "WalletWizard", score: 3, streak: 0 },
    { name: "BitBoss", score: 3, streak: 0 },
    { name: "HODLHustler", score: 2, streak: 0 },
    { name: "DeFiDragon", score: 1, streak: 0 },
  ];
  
  export default leaderboardData;
  